import { createAsyncThunk } from "@reduxjs/toolkit";
import type { HotelsState } from "../../../../store";
import type { AvailabilityApiCall } from "./api/fetchAvailability";
import { fetchHotelsNextPage } from "./fetchHotelsNextPage";
import { fetchInitialHotels } from "./fetchInitialHotels";

export const fetchHotels = createAsyncThunk<
  void,
  AvailabilityApiCall,
  { state: HotelsState; rejectValue: { error: string } }
>("hotelsAvailability/fetchHotels", async (req, thunkAPI) => {
  try {
    const initialResponse = await thunkAPI.dispatch(fetchInitialHotels(req));

    if (
      fetchInitialHotels.fulfilled.match(initialResponse) &&
      initialResponse.payload?.nextPageToken != null
    ) {
      let nextPageToken: string | null = initialResponse.payload.nextPageToken;
      const searchId: string | null = initialResponse.payload.searchId;

      while (nextPageToken != null) {
        const nextPageResponse = await thunkAPI.dispatch(
          fetchHotelsNextPage({ nextPageToken, searchId: searchId })
        );

        const state = thunkAPI.getState();

        if (
          fetchHotelsNextPage.fulfilled.match(nextPageResponse) &&
          nextPageResponse.payload?.nextPageToken != null &&
          state.hotels.hotelsAvailability.hotels.data?.searchId === searchId
        ) {
          nextPageToken = nextPageResponse.payload.nextPageToken;
        } else {
          nextPageToken = null;
        }
      }
    }
  } catch (error) {
    console.error("Failed to fetch hotels:", error);
    return thunkAPI.rejectWithValue({ error: "Failed to fetch hotels" });
  }
});
